module.exports = __webpack_public_path__ + "static/media/NCP_firstPage_en.97589b48.png";